import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import { PolicyProvider } from './context/PolicyContext';
import CreatePolicy from './components/CreatePolicy';
import RetrievePolicy from './components/RetrievePolicy';
import CancelPolicy from './components/CancelPolicy';
import ReinstatePolicy from './components/ReinstatePolicy';
import RenewPolicy from './components/RenewPolicy';
import AddIncident from './components/AddIncident';
import './App.css';

function App() {
  return (
    <PolicyProvider>
      <Router>
        <div className="app">
          <nav className="navbar">
            <div className="nav-container">
              <h1 className="nav-logo">Insurance Management</h1>
              <ul className="nav-menu">
                <li><Link to="/">Create Policy</Link></li>
                <li><Link to="/retrieve">Retrieve Policy</Link></li>
                <li><Link to="/cancel">Cancel Policy</Link></li>
                <li><Link to="/reinstate">Reinstate Policy</Link></li>
                <li><Link to="/renew">Renew Policy</Link></li>
                <li><Link to="/incident">Add Incident</Link></li>
              </ul>
            </div>
          </nav>

          <main className="main-content">
            <Routes>
              <Route path="/" element={<CreatePolicy />} />
              <Route path="/retrieve" element={<RetrievePolicy />} />
              <Route path="/cancel" element={<CancelPolicy />} />
              <Route path="/reinstate" element={<ReinstatePolicy />} />
              <Route path="/renew" element={<RenewPolicy />} />
              <Route path="/incident" element={<AddIncident />} />
            </Routes>
          </main>
        </div>
      </Router>
    </PolicyProvider>
  );
}

export default App;


